import React from "react";
import { useState } from "react";
import * as  Tooltip from "@radix-ui/react-tooltip";
import { ReactComponent as PlaneIcon } from '../../../assets/icons/icon-plane.svg';
import { cn } from "../../../lib";

export function TooltipPortal({ title, content, className }) {
  const [open, setOpen] = useState(false);

  return (
    <Tooltip.Provider delayDuration={0}>
      <Tooltip.Root open={open} onOpenChange={setOpen}>
        <Tooltip.Trigger asChild>
          <div
            className="relative text-sm py-2 h-full flex items-center bg-warning px-2 text-white font-bold rounded-tr-md cursor-pointer"
            onClick={() => setOpen(prev => !prev)}
          >
            <span>{title}</span>
            <PlaneIcon className="ml-2 text-white" />
          </div>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            side="top"
            align="center"
            sideOffset={8}
            className="relative z-50"
          >
            <div
              className={cn(
                "bg-warning text-white text-center px-6 py-3 rounded-3xl max-w-xs text-sm font-bold shadow-lg relative",
                className
              )}
            >
              {content}
              <Tooltip.Arrow className="fill-warning" width={20} height={10} />
            </div>
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}


export default TooltipPortal;